import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import { USER_DETAIL_QUERY_KEYS } from '../../common/queryKeys';
import { MemberMigrationRepository } from '../UserInfoTrasferSection/repositories/MemberMigrationRepository';
import { MemberMigrationRequestOptionType, MemberMigrationResponseType } from '../UserInfoTrasferSection/types';

export const useMigrateMemberMutation = (
  options: UseMutationOptions<MemberMigrationResponseType, Error, MemberMigrationRequestOptionType>,
): UseMutationResult<MemberMigrationResponseType, Error, MemberMigrationRequestOptionType> =>
  useMutation<MemberMigrationResponseType, Error, MemberMigrationRequestOptionType>(
    USER_DETAIL_QUERY_KEYS.MIGRATION,
    MemberMigrationRepository.migrateMember,
    { ...options },
  );
